// What onboarding is, as data. React-free, so a native app can render the
// same screens from the same list.

import type { UiKey } from "../i18n/en.ts";

export type OnboardingStepId = "welcome" | "method" | "memory" | "tree";

export interface OnboardingStep {
	id: OnboardingStepId;
	title: UiKey;
	body: UiKey;
}

/** The screens in order. Each view draws its own art for an id. */
export const STEPS: readonly OnboardingStep[] = [
	{ id: "welcome", title: "onboarding.welcomeTitle", body: "onboarding.welcomeBody" },
	{ id: "method", title: "onboarding.methodTitle", body: "onboarding.methodBody" },
	{ id: "memory", title: "onboarding.memoryTitle", body: "onboarding.memoryBody" },
	{ id: "tree", title: "onboarding.treeTitle", body: "onboarding.treeBody" },
];
